import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
import MessagesTable from '../components/MessagesTable';
import MessageDetail from '../components/MessageDetail';
import MessageSidebar from '../components/MessagesSideBar';
import ComposeMessage from '../components/ComposeMessage';
import { useMessages } from '../hooks/useMessages';
import { Message } from '../../../../types/messageTypes';
import { Spinner, Button } from 'react-bootstrap';
import PageHeader from "components/Common/PageHeader";
import CustomButton from "components/Common/ui/CustomButton";
import { Spin } from "antd";
import Loader from "components/Common/loader";
import { useAbility } from "config/abilityContext";
// import { useAbility } from "config/abilityContext";

const MessagesPage: React.FC = () => {
  const [selectedMessage, setSelectedMessage] = useState<Message | null>(null);
  const [selectedType, setSelectedType] = useState<'inbox' | 'sent' | 'getAll'>('inbox');
  const [isComposing, setIsComposing] = useState<boolean>(false); // Track compose mode
  const ability = useAbility();

  // Helper to close compose and message detail when tab changes
  const handleTypeChange = (type: 'inbox' | 'sent' | 'getAll') => {
    setSelectedType(type);
    setIsComposing(false);
    setSelectedMessage(null); // Also close message detail
  }
  // Fetch messages using the custom hook
  const { messages, pagination, loading, error, setPage, setLimit } = useMessages(selectedType);

  const { t } = useTranslation();
  const renderSidebar = (
  ) => (
    <MessageSidebar
      selectedType={selectedType}
      onTypeChange={handleTypeChange} // Switch between Inbox and Sent and close compose
    />
  );

  const renderMessagesTable = () => (
    <MessagesTable
      messages={messages}
      pagination={pagination}
      onPageChange={(page, pageSize) => {
        setPage(page);
        setLimit(pageSize);
      }}
      onMessageSelect={setSelectedMessage} // Select a message for detail view
    />
  );

  const renderMessageDetail = () => (
    <MessageDetail
      message={selectedMessage as Message}
      onBack={() => setSelectedMessage(null)} // Return to the table view
    />
  );

  const renderComposeEmail = () => (
    <ComposeMessage
      onBack={() => setIsComposing(false)}
    />
  );

  const renderContent = () => {
    if (isComposing) {
      return renderComposeEmail(); // Render ComposeEmail if composing
    }

    if (loading) {
      return <Loader />;
    }

    if (error) {
      return <p className="text-danger">{error}</p>;
    }

    return selectedMessage ? renderMessageDetail() : renderMessagesTable();
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("messaging")}
          breadcrumbItems={[
            { label: "dashboard", path: "/dashboard" },
            { label: "messaging", active: true }
          ]}
        />
        <div className="d-flex justify-content-end gap-2">
          {ability.can("create", "Message") && (
            <CustomButton onClick={() => setIsComposing(true)} variant="primary">
              <i className="ti ti-plus me-2" />
              {t("add_messaging")}
            </CustomButton>
          )}
        </div>

        {renderSidebar()}
      <div className="mt-3">
         {renderContent()} 
      </div>
      </div>
    </div>
  );
};

export default MessagesPage;
